import { TextLink } from '@components/Typography/TextLink/TextLink';
import type { FAQHit } from 'pages/faqs/search-results';

export function FaqsList({ data }: { data: FAQHit[] }) {
  return (
    <div className="ga-search-list ga-search-faqs flex flex-col gap-2 pb-8">
      {data.map((hit) => (
        <div
          key={hit.slug}
          className="border-0 border-b border-solid border-grey-light px-0 pb-2"
        >
          <TextLink
            href={hit.slug}
            data-umami-event-location="Search Result Card Faq"
          >
            <span className="text-lg">{hit.title}</span>
          </TextLink>
        </div>
      ))}
    </div>
  );
}
